import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'durationFormat' })
export class DurationFormatPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(totalMinutes?: number | null) {
    if (totalMinutes === undefined || totalMinutes === null) return '';

    const days = Math.floor(totalMinutes / 1440);
    const hrs = Math.floor((totalMinutes % 1440) / 60);
    const mins = totalMinutes % 60;

    const result =
      days > 0
        ? `${days} ${this.translate.instant('duration.days')} ${hrs} ${this.translate.instant('duration.hrs')}`
        : hrs > 0
        ? `${hrs} ${this.translate.instant('duration.hrs')}`
        : '';

    return (result + ` ${mins} ${this.translate.instant('duration.mins')}`).trim();
  }
}
